import { computed, reactive } from "vue";

export function useCart() {
    const errors = reactive<Record<string, any>>({});
    const state = reactive<Record<string, any>>({});

    const cartIsEmpty = computed(() => state.cartQuantity === 0);

    function onCartItemUpdated(data: any) {
        delete errors[data.cartItemId];
        state.cart = data.cart;
        state.cartQuantity = data.cartQuantity;
        state.cartTotals = data.cartTotals;
        state.discounts = data.discounts;
        state.tips = data.tips;
        state.shippingTimeId = data.shippingTimeId;
        state.shippingOptions = data.shippingOptions;
    }

    function onCartItemError(error: any) {
        delete errors[error.cartItemId];
        for (const field in error.data.errors) {
            errors[error.cartItemId] = {};
            errors[error.cartItemId][field] = error.data.errors[field][0];
        }
    }

    function onShippingOptionUpdated(data: any) {
        delete errors["shipping_option"];
        state.shippingTimeId = data.shippingTimeId;
        state.cartTotals = data.cartTotals;
        state.discounts = data.discounts;
        state.tips = data.tips;
    }

    function onShippingOptionError(error: any) {
        delete errors["shipping_option"];
        errors.shipping_option = error.data.errors.shipping_option[0];
    }

    function onShippingRegionUpdated(data: any) {
        delete errors["country_code"];
        delete errors["region"];
        state.cartTotals = data.cartTotals;
        state.discounts = data.discounts;
        state.tips = data.tips;
        state.country = data.country;
        state.region = data.region;
        state.shippingTimeId = data.shippingTimeId;
        state.shippingOptions = data.shippingOptions;
    }

    function onShippingRegionError(error: any) {
        delete errors["country_code"];
        delete errors["region"];

        if (
            Object.prototype.hasOwnProperty.call(
                error.data.errors,
                "country_code",
            )
        ) {
            errors.country_code = error.data.errors.country_code[0];
        }
        if (Object.prototype.hasOwnProperty.call(error.data.errors, "region")) {
            errors.region = error.data.errors.region[0];
        }
    }

    function onCouponApplied(data: any) {
        delete errors["coupon_code"];
        state.cartTotals = data.cartTotals;
        state.discounts = data.discounts;
        state.tips = data.tips;
        state.shippingTimeId = data.shippingTimeId;
        state.shippingOptions = data.shippingOptions;
    }

    function onCouponError(error: any) {
        delete errors["coupon_code"];
        errors.coupon_code = error.data.errors.coupon_code[0];
    }

    function onCouponRemoved(data: any) {
        delete errors["coupon_code"];
        state.cartTotals = data.cartTotals;
        state.discounts = data.discounts;
        state.tips = data.tips;
        state.shippingTimeId = data.shippingTimeId;
        state.shippingOptions = data.shippingOptions;
    }

    function onPaypalTokenGenerated(data: any) {
        delete errors["paypal_token"];
        state.paypalToken = data.paypal_token;
    }

    function onPaypalTokenError(error: any) {
        delete errors["paypal_token"];
        errors.paypal_token = error.data.errors.paypal_token[0];
    }

    return {
        errors,
        state,
        cartIsEmpty,
        onCartItemError,
        onCartItemUpdated,
        onShippingOptionError,
        onShippingOptionUpdated,
        onShippingRegionUpdated,
        onShippingRegionError,
        onCouponApplied,
        onCouponError,
        onCouponRemoved,
        onPaypalTokenGenerated,
        onPaypalTokenError,
    };
}
